export const initEmbedMode = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  try {
    const params = new URLSearchParams(window.location.search || '');
    const value = String(params.get('embed') || '').toLowerCase();
    if (value === 'true') {
      document.documentElement.setAttribute('data-embed', 'true');
    }
  } catch {
    // no-op
  }
};
